import React, { useState } from "react";
import {
  Card,
  Center,
  Heading,
  Flex,
  Box,
  Select,
  Grid,
} from "@chakra-ui/react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// Custom Components
import CustomInput from "../../components/CustomInput";
import CustomButton from "../../components/ButtonComp";
import SelectImage from "../../components/SelectImage";
import CustomSingleInput from "../../components/CustomSingleInput";
import { baseUrl } from "../../utils/utils";

const DriverSchema = Yup.object().shape({
  name: Yup.string().required("Driver name is required"),
  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[6-9]\d{9}$/, "Invalid mobile number"),
  email: Yup.string().email().required("Email is required"),
  address: Yup.string().required("Address is required"),

  aadhaar: Yup.string().required("Aadhaar number is required"),
  aadhaarFile: Yup.mixed().required("Aadhaar document is required"),

  licenseNumber: Yup.string().required("License number is required"),
  licenseFile: Yup.mixed().required("License document is required"),
});

const AddDriver = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialValues = {
    name: "",
    mobile: "",
    email: "",
    address: "",
    aadhaar: "",
    aadhaarFile: null,
    licenseNumber: "",
    licenseFile: null,
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      setIsSubmitting(true);

      const formData = new FormData();
      formData.append("action", "create");
      formData.append("name", values.name);
      formData.append("mobile1", values.mobile);
      formData.append("mobile2", values.mobile);
      formData.append("email", values.email);
      formData.append("address", values.address);
      formData.append("aadhar", values.aadhaar);
      formData.append("pan", "ABCPD1234E");
      formData.append("password", "Test@123");

      formData.append("drivinglicense", values.licenseNumber);
      formData.append("documentscount", 2);
      formData.append("names", "aadhar,,,pan");
      formData.append("document0", values.aadhaarFile);
      formData.append("document1", values.licenseFile);

      const response = await fetch(baseUrl + "driver.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      //   if (!result.status || result.status !== "success") {
      //     throw new Error(result.message || "Something went wrong");
      //   }
      //   toast.success("Driver added successfully");
      if (result.success) {
        toast.success(result.message);
        resetForm();
        navigate("/driver-list");
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error(error.message || "Failed to create driver");
    } finally {
      setIsSubmitting(false);
      setSubmitting(false);
    }
  };

  return (
    <>
      <Card
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justify={"space-between"}
        paddingInline={5}
        paddingBlock={2}
        mb={4}
      >
        <Heading fontSize={"xl"}>Add Driver</Heading>
        <CustomButton
          icon={<BiArrowBack color="#fff" />}
          title={"Back"}
          height={"30px"}
          b_color={"#000"}
          onClick={() =>
            navigate("/driver-list", {
              state: {
                page: location.state?.page,
                rows: location.state?.rows
              }
            })
          }
        />
      </Card>

      <Formik
        initialValues={initialValues}
        validationSchema={DriverSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          handleChange,
          handleBlur,
          setFieldValue,
          touched,
          errors,
          submitForm,
        }) => (
          <Form>
            <Card paddingInline={5} paddingBlock={5}>
              <CustomInput
                label1="Driver Name"
                placeholder1="Enter driver name"
                value1={values.name}
                onChange1={handleChange("name")}
                onBlur1={handleBlur("name")}
                error1={touched.name && errors.name}
                required1={true}
                label2="Mobile Number"
                placeholder2="Enter 10-digit mobile"
                value2={values.mobile}
                onChange2={handleChange("mobile")}
                onBlur2={handleBlur("mobile")}
                error2={touched.mobile && errors.mobile}
                required2={true}
              />
              <CustomInput
                label1="Email"
                placeholder1="Enter your email"
                value1={values.email}
                onChange1={handleChange("email")}
                onBlur1={handleBlur("email")}
                error1={touched.email && errors.email}
                required1={true}
                label2="Address"
                placeholder2="Enter your Address"
                value2={values.address}
                onChange2={handleChange("address")}
                onBlur2={handleBlur("address")}
                error2={touched.address && errors.address}
                required2={true}
                x
              />

              <Grid templateColumns={["1fr", null, "repeat(2, 1fr)"]} gap={4}>
                {/* Aadhaar Number */}
                <CustomSingleInput
                  label={"Aadhaar Number"}
                  value={values.aadhaar}
                  onChange={handleChange("aadhaar")}
                  onBlur={handleBlur("aadhaar")}
                  placeholder={"Enter Aadhaar Number"}
                  error={touched.aadhaar && errors.aadhaar}
                  required={true}
                />
                <SelectImage
                  mt={0.01}
                  label={"Aadhaar Document"}
                  filename={values.aadhaarFile?.name}
                  error={touched.aadhaarFile && errors.aadhaarFile}
                  onChange={(file) => setFieldValue("aadhaarFile", file)}
                  required
                />

                {/* Driving License Number */}
                <CustomSingleInput
                  label={"Driving License Number"}
                  value={values.licenseNumber}
                  onChange={handleChange("licenseNumber")}
                  onBlur={handleBlur("licenseNumber")}
                  placeholder={"Enter Driving License Number"}
                  error={touched.licenseNumber && errors.licenseNumber}
                  required={true}
                />
                <SelectImage
                  mt={0.01}
                  label={"Driving License Document"}
                  filename={values.licenseFile?.name}
                  error={touched.licenseFile && errors.licenseFile}
                  onChange={(file) => setFieldValue("licenseFile", file)}
                  required
                />
              </Grid>

              <Center mt={6}>
                <CustomButton
                  title={isSubmitting ? "Submitting..." : "Create Driver"}
                  onClick={submitForm}
                  disabled={isSubmitting}
                />
              </Center>
            </Card>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddDriver;
